export default {
  buttons: {
    signup: 'Registrati',
    login: 'Accedi',
  },
};
